import { render, staticRenderFns } from "./FrsRocketHeaderSettings.vue?vue&type=template&id=f8b0a242&scoped=true&lang=html&"
import script from "./FrsRocketHeaderSettings.vue?vue&type=script&lang=js&"
export * from "./FrsRocketHeaderSettings.vue?vue&type=script&lang=js&"
import style0 from "./FrsRocketHeaderSettings.vue?vue&type=style&index=0&id=f8b0a242&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b0a242",
  null
  
)

export default component.exports